import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-unauth-layout',
  imports: [RouterModule],
  templateUrl: './unauth-layout.component.html',
  styleUrl: './unauth-layout.component.scss'
})
export class UnauthLayoutComponent {}
